import { MessageMarkerEntity, MessageMarkerStatus } from './entities';

// Re-export for convenience
export { MessageMarkerStatus, type MessageMarkerEntity };

// Message Marker Status Labels
export const MESSAGE_MARKER_STATUS_LABELS: Record<MessageMarkerStatus, string> = {
    [MessageMarkerStatus.SIGNIFICANT]: 'Significant',
    [MessageMarkerStatus.VALUABLE_TO_CLIENT]: 'Valuable to Client',
    [MessageMarkerStatus.CONCERN]: 'Concern',
    [MessageMarkerStatus.TRAINING_EXAMPLE]: 'Training Example',
    [MessageMarkerStatus.FOLLOW_UP_NEEDED]: 'Follow-up Needed',
};

// Message Marker Status Colors (for HeroUI chips)
export const MESSAGE_MARKER_STATUS_COLORS: Record<
    MessageMarkerStatus,
    'primary' | 'success' | 'warning' | 'danger' | 'default' | 'secondary'
> = {
    [MessageMarkerStatus.SIGNIFICANT]: 'primary',
    [MessageMarkerStatus.VALUABLE_TO_CLIENT]: 'secondary',
    [MessageMarkerStatus.CONCERN]: 'danger',
    [MessageMarkerStatus.TRAINING_EXAMPLE]: 'success',
    [MessageMarkerStatus.FOLLOW_UP_NEEDED]: 'warning',
};

// Message Marker Status Icons
export const MESSAGE_MARKER_STATUS_ICONS: Record<MessageMarkerStatus, string> = {
    [MessageMarkerStatus.SIGNIFICANT]: 'lucide:star',
    [MessageMarkerStatus.VALUABLE_TO_CLIENT]: 'lucide:check-circle',
    [MessageMarkerStatus.CONCERN]: 'lucide:alert-triangle',
    [MessageMarkerStatus.TRAINING_EXAMPLE]: 'lucide:graduation-cap',
    [MessageMarkerStatus.FOLLOW_UP_NEEDED]: 'lucide:clock',
};

// Create Message Marker DTO
export interface CreateMessageMarkerDto {
    conversationId: string;
    messageId: string;
    status: MessageMarkerStatus;
    notes?: string;
    userMessage?: string;
    aiResponse?: string;
}

// Update Message Marker DTO
export interface UpdateMessageMarkerDto {
    status?: MessageMarkerStatus;
    notes?: string;
}

// Message Markers Query Parameters
export interface GetMessageMarkersQuery {
    status?: MessageMarkerStatus;
    conversationId?: string;
    searchTerm?: string;
    page?: number;
    limit?: number;
    sortBy?: string;
}

// Message Markers Response
export interface GetMessageMarkersResponse {
    data: MessageMarkerEntity[];
    pagination: {
        page: number;
        limit: number;
        total: number;
        totalPages: number;
    };
}
